import type { ListParams } from './types';

import { SEO_LIMITS } from './constants';

export function generateSlug(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
}

export function calculateReadingTime(wordCount: number): number {
  return Math.ceil(wordCount / 200);
}

export function calculateSeoScore(title: string, description: string, hasOgImage: boolean): number {
  let score = 0;
  if (title.length > 0 && title.length <= SEO_LIMITS.META_TITLE_MAX) score += 40;
  else if (title.length > 0) score += 20;

  if (description.length > 0 && description.length <= SEO_LIMITS.META_DESCRIPTION_MAX) score += 40;
  else if (description.length > 0) score += 20;

  if (hasOgImage) score += 20;

  return score;
}

// Serialise list filters to a query string; ApiFetch.get takes a bare endpoint
// (same pattern as audit-logs' buildQuery). Undefined values are dropped.
export function toQuery(params?: ListParams): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== '');
  return entries.length ? '?' + new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString() : '';
}
